import { atom } from "recoil";

export const acceptTermsStatus = atom({
  key: "acceptTerms",
  default: null,
});
